module.exports = __webpack_public_path__ + "static/media/muamalat.20f79500.png";